<template>
  <div>
    <app-popup :active.sync="active" title="Загрузка файлов" width="320px">
      <div>
        <UploadFilesItem v-for="(file, fileIndex) in files" :key="`file-${fileIndex}`" :file="file" @deleteFile="deleteFile(fileIndex)"/>
      </div>

      <div class="issue-upload-files-popup__add link-icon">
        <app-icon name="PlusIcon" size="8px"/>
        Добавить ещe
        <input type="file" multiple ref="inputFiles" @change="addFiles" class="issue-upload-files-popup__files-input">
      </div>

      <div class="issue-upload-files-popup__footer">
        <div class="issue-upload-files-popup__message" ref="issueNewMessage" contenteditable="true" @keyup="setMessage"
             placeholder="Напишите ваше сообщение..." @keypress.enter="sendMessage">
        </div>
        <div class="issue-upload-files-popup__send link-icon" @click="sendMessage">
          <app-icon name="SendIcon"/>
        </div>
      </div>

    </app-popup>
  </div>
</template>

<script>
  import UploadFilesItem from "./UploadFilesItem";

  export default {
    name: "UploadFilesPopup",
    components: {UploadFilesItem},
    data(){
      return {
        files: [],
        active: false,
        message: "",
      }
    },
    methods: {
      resetMessage(){
        this.$nextTick(() => {
          this.message = '';
          let input = this.$refs.issueNewMessage;
          while (input.firstChild)
            input.removeChild(input.firstChild);

          input.blur();
        });
      },
      open(files, message=""){
        this.resetMessage();
        this.files = Array.from(files);
        this.active = true;
        this.$nextTick(() => {
          this.$refs.issueNewMessage.innerText = message;
          this.message = message;
        });
      },
      addFiles(){
        let files = this.$refs.inputFiles.files;
        files = Array.from(files);
        this.files = this.files.concat(...files);
      },
      deleteFile(index){
        this.files.splice(index, 1);
      },
      setMessage(e){
        const target = e.target;
        let value = target.textContent || target.innerText;
        value = value.replace(/\s{2,}/g, ' ');
        this.message = value.trim();
      },
      sendMessage(){
        this.$emit('send', {
          message: this.message,
          files: this.files,
        });
        this.active = false;
      }
    },
    watch: {
      files(){
        if(this.files.length === 0){
          this.active = false
        }
      }
    }
  }
</script>

<style lang="scss">
.issue-upload-files-popup{
  &__footer{
    margin: 1rem -1rem -1rem;
    display: flex;
    align-items: flex-end;
    border-top: 1px solid rgba(0,0,0,.1);
  }

  &__add{
    margin-top: 2rem;
    text-align: center;
    font-size: .71rem;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    position: relative;

    .app-icon{
      display: flex;
      margin-right: 5px;
    }
  }

  &__files-input{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 0;
    overflow: hidden;
    opacity: 0;
    z-index: 1;
    width: 100%;
  }

  &__message{
    appearance: textfield;
    flex: 0 1 100%;
    display: inline-block;
    max-height: 200px;
    overflow-y: auto;
    line-height: 1.2;
    padding: 5px 10px;
    align-self: center;
    word-break: break-word;
    white-space: pre-wrap;

    &[placeholder]:empty:before {
      content: attr(placeholder);
      color: #555;
    }

    &[placeholder]:empty:focus:before {
      content: "";
    }
  }

  &__send{
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
  }
}
</style>
